<div class="version-container">
  <app-sidenav-header [title]="title"></app-sidenav-header>
  <mat-tab-group [selectedIndex]="selectedIndex">
    <mat-tab disabled>
      <ng-template mat-tab-label>
        <div class="flex flex-row justify-center items-center enable" (click)="tabChanged(0)">
          <mat-icon *ngIf="tabValidation.basic" svgIcon="done" class="icon-sm mr-4"></mat-icon>
          {{'ADD_VERSION.BASIC' | transloco }}
        </div>
      </ng-template> 
      <div class="p-24" class="form-section pr-10">
        <form [formGroup]="createVersionForm" class="p-8">
        
          <div class="flex flex-row gap-8">
            <div class="flex flex-col form-fields mb-16">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.BUILD_VERSION_NAME' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.BUILD_VERSION_NAME' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <input formControlName="name" placeholder="{{'ADD_VERSION.BUILD_VERSION_NAME' | transloco}}" class="fw-500" required>
              <app-error [control]="createVersionForm.get('name')"></app-error>
            </div>
            <div class="flex flex-row gap-4 form-fields">
              <div class="flex flex-col form-fields mb-16">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.BUILD_VERSION' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.BUILD_VERSION' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="version" placeholder="{{'ADD_VERSION.BUILD_VERSION' | transloco}}" class="fw-500" required>
                <app-error [control]="createVersionForm.get('version')"></app-error>
              </div>
              <div class="flex flex-col form-fields mb-16">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.RELEASE_VERSION' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip left" [matTooltip]="'ADD_VERSION.RELEASE_VERSION' | transloco"
                    matTooltipPosition="{{Constants.POSITION_LEFT}}"></mat-icon>
                </div>
                <input formControlName="releaseVersion" placeholder="{{'ADD_VERSION.RELEASE_VERSION' | transloco}}" class="fw-500" required>
                <app-error [control]="createVersionForm.get('releaseVersion')"></app-error>
              </div>
            </div>
          </div>

          <div class="flex flex-row gap-8">
            <div class="flex flex-col form-fields mb-16">
              <div class="flex flex-row justify-start items-center pb-4">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.PATCH_FLAG' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4 mr-16" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.PATCH_FLAG' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                <mat-slide-toggle [checked]="patchFlagValue" (change)="patchFlagChange($event)">{{ (patchFlagValue ? 'ADD_VERSION.TRUE' : 'ADD_VERSION.FALSE') | transloco}}</mat-slide-toggle>
              </div>
              <div class="flex flex-row justify-start items-center read-only pl-10">{{ (patchFlagValue ? 'ADD_VERSION.TRUE' : 'ADD_VERSION.FALSE') | transloco}}</div>
            </div>
            <div class="flex flex-col form-fields mb-16">
              <div class="flex flex-row justify-start items-center pb-4">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.STATUS' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.STATUS' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <select [formControl]="createVersionForm.get('status')" class="fw-500 form-select" required>
                <option [ngValue]="null" [disabled]="true" hidden>{{'ADD_VERSION.STATUS' | transloco}}</option>
                <option *ngFor="let option of statusOptions" [ngValue]="option">{{ option | titlecase }}</option>
              </select>
              <app-error [control]="createVersionForm.get('status')"></app-error>
            </div>
          </div>

          <div class="flex flex-col mb-16">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.DESCRIPTION' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.DESCRIPTION' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <textarea formControlName="description" placeholder="{{'ADD_VERSION.DESCRIPTION' | transloco}}" class="fw-500 text-area" required></textarea>
            <app-error [control]="createVersionForm.get('description')"></app-error>
          </div>

          <div class="flex flex-col mb-16">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.RELEASE_NOTES' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.RELEASE_NOTES' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <textarea formControlName="releaseNotes" placeholder="{{'ADD_VERSION.RELEASE_NOTES' | transloco}}" class="fw-500 text-area" required></textarea>
            <app-error [control]="createVersionForm.get('releaseNotes')"></app-error>
          </div>

          <div class="flex flex-row gap-8">
            <div class="flex flex-col form-fields mb-24">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.PRODUCT_VERSION_MAP' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.PRODUCT_VERSION_MAP' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <input formControlName="productVersionMap" placeholder="{{'ADD_VERSION.PRODUCT_VERSION_MAP' | transloco}}" class="fw-500" required>
              <app-error [control]="createVersionForm.get('productVersionMap')"></app-error>
            </div>
            <div class="flex flex-col form-fields mb-24">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.SPEC_VERSION' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.SPEC_VERSION' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <input formControlName="specVersion" placeholder="{{'ADD_VERSION.SPEC_VERSION' | transloco}}" class="fw-500" required>
              <app-error [control]="createVersionForm.get('specVersion')"></app-error>
            </div>
          </div>

          <div class="sub-form mb-16">
            <div class="mat-subtitle-2 mb-0 fs-14 fw-700 pt-8 pr-8 pl-8">{{'ADD_VERSION.CBASE' | transloco | uppercase }}</div>
            <div class="flex flex-row gap-x-4 pt-4 pr-8 pl-8 pb-20">
              
              <div class="flex flex-col form-fields">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.NAME' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.NAME' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="cbaseName" placeholder="{{'ADD_VERSION.NAME' | transloco}}" class="fw-500 w-100-percent" required>
                <app-error [control]="createVersionForm.get('cbaseName')"></app-error>
              </div>

              <div class="flex flex-col form-fields">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.VERSION' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.VERSION' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="cbaseVersion" placeholder="{{'ADD_VERSION.VERSION' | transloco}}" class="fw-500 w-100-percent" required>
                <app-error [control]="createVersionForm.get('cbaseVersion')"></app-error>
              </div>

              <div class="flex flex-col form-fields">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.DISABLED' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.DISABLED' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="cbaseDisabled" placeholder="{{'ADD_VERSION.DISABLED' | transloco}}" class="fw-500 w-100-percent" required>
                <app-error [control]="createVersionForm.get('cbaseDisabled')"></app-error>
              </div>
            </div>
          </div>
          
          <div class="sub-form mb-16">
            <div class="mat-subtitle-2 mb-0 fs-14 fw-700 pt-8 pr-8 pl-8">{{'ADD_VERSION.ATF' | transloco | uppercase }}</div>
            <div class="flex flex-row pt-4 pr-8 pl-8 pb-20 gap-8">
              <div class="flex flex-col form-fields">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.NAME' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.NAME' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="atfName" placeholder="{{'ADD_VERSION.NAME' | transloco}}" class="fw-500 w-100-percent" required>
                <app-error [control]="createVersionForm.get('atfName')"></app-error>
              </div>

              <div class="flex flex-col form-fields">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.VERSION' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.VERSION' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="atfVersion" placeholder="{{'ADD_VERSION.VERSION' | transloco}}" class="fw-500 w-100-percent" required>
                <app-error [control]="createVersionForm.get('atfVersion')"></app-error>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mat-tab>
    <mat-divider></mat-divider>
    <mat-tab disabled>
      <ng-template mat-tab-label>
        <div class="flex flex-row justify-center items-center enable" (click)="tabChanged(1)">
          <mat-icon *ngIf="tabValidation.capability" svgIcon="done" class="icon-sm mr-4"></mat-icon>
          {{'ADD_VERSION.CAPABILITY' | transloco }}
        </div>
      </ng-template>
      <div class="form-section">
        <div class="flex flex-row justify-between items-center p-8">
          <div class="fw-700">
            <span>{{'ADD_VERSION.ADDED_CAPABILITIES' | transloco }}</span>
          </div>
          <div class="flex flex-row fw-700 cursor-pointer" (click)="addCapability()">
            <mat-icon svgIcon="add" class="icon-md mr-4"></mat-icon>
            {{'ADD_VERSION.ADD_CAPABILITY' | transloco }}
          </div>
        </div>

        <div class="flex flex-col border-radius m-4" *ngIf="!loading">
          <table mat-table [dataSource]="dataSource" [matSortActive]="sortInfo.active" [matSortDirection]="sortInfo.direction" 
            matSortDisableClear class="mat-elevation" matSort (matSortChange)="sortData($event)">
            <ng-container matColumnDef="capability">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'ADD_VERSION.CAPABILITY' | transloco | uppercase }} </th>
              <td mat-cell *matCellDef="let data"> {{data.capability}} </td>
            </ng-container>
      
            <ng-container matColumnDef="version">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'ADD_VERSION.VERSION' | transloco | uppercase }} </th>
              <td mat-cell *matCellDef="let data"> {{data.version}} </td>
            </ng-container>
      
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'ADD_VERSION.TYPE' | transloco | uppercase }} </th>
              <td mat-cell *matCellDef="let data"> {{data.type}} </td>
            </ng-container>
      
            <ng-container matColumnDef="icon">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
              <td mat-cell *matCellDef="let data; let i = index"> 
                <mat-icon svgIcon="edit" class="cursor-pointer icon-md mr-16" (click)="editCapability(i)"></mat-icon>
                <mat-icon svgIcon="delete" class="cursor-pointer icon-md mr-16 delete-icon" (click)="deleteCapability(i)"></mat-icon>
              </td>
            </ng-container>
      
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <div *ngIf="dataSource?.length === 0" class="flex flex-col justify-center items-center pt-20 add-capability">
          <mat-icon svgIcon="checklist" class="icon-md-1 mr-4"></mat-icon>
          {{'ADD_VERSION.ADD_CAPABILITY' | transloco }}
        </div>
      </div>
    
    </mat-tab>
    <mat-tab disabled>
      <ng-template mat-tab-label>
        <div class="flex flex-row justify-center items-center enable" (click)="tabChanged(2)">
          <mat-icon *ngIf="tabValidation.installSpec" svgIcon="done" class="icon-sm mr-4"></mat-icon>
          {{'ADD_VERSION.INSTALLATION_SPECIFICATION' | transloco }}
        </div>
      </ng-template>
      <div class="form-section">
        <form [formGroup]="createSpecForm" class="p-8">
          <div class="flex flex-col mb-16">
            <div class="flex flex-row justify-between items-center mb-4">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.INSTALLATION_SPECIFICATION' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.INSTALLATION_SPECIFICATION' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <mat-slide-toggle [checked]="encryptionKeys.buildInstallSpec" (change)="encryptData($event)">{{ (encryptionKeys.buildInstallSpec ? 'ADD_VERSION.DECODE' : 'ADD_VERSION.ENCODE') | transloco}}</mat-slide-toggle>
            </div>
            <textarea formControlName="installationSpecification" placeholder="{{'ADD_VERSION.INSTALLATION_SPECIFICATION' | transloco}}" class="fw-500 spec-text-area" required></textarea>
            <app-error [control]="createSpecForm.get('installationSpecification')"></app-error>
          </div>
        </form>
      </div>
    </mat-tab>
    <mat-tab disabled>
      <ng-template mat-tab-label>
        <div class="flex flex-row justify-center items-center enable" (click)="tabChanged(3)">
          <mat-icon *ngIf="tabValidation.review" svgIcon="done" class="icon-sm mr-4"></mat-icon>
          {{'ADD_VERSION.REVIEW' | transloco }}
        </div>
      </ng-template>
      <div class="form-section review-section pr-10">
        <div class="flex flex-row justify-between items-center mat-subtitle-2 mb-0 fs-20 fw-700 pb-8">
          <div class="pb-4">{{'ADD_VERSION.BASIC' | transloco }}</div>
          <div class="flex flex-row cursor-pointer" (click)="selectedIndex = 0">
            <mat-icon svgIcon="edit" class="cursor-pointer icon-md mr-8"></mat-icon>
            <span>{{'ADD_VERSION.EDIT' | transloco }}</span>
          </div>
        </div>
        <div class="flex flex-row flex-wrap gap-x-4">
          <div class="form-fields">
            <label class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'ADD_VERSION.BUILD_VERSION_NAME' | transloco | uppercase }}</label>
            <div class="review-metrics">{{createVersionForm.getRawValue().name}}</div>
          </div>
          <div class="form-fields">
            <label class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'ADD_VERSION.BUILD_VERSION' | transloco | uppercase }}</label>
            <div class="review-metrics">{{createVersionForm.getRawValue().version}}</div>
          </div>
          <div class="form-fields">
            <label class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'ADD_VERSION.PATCH_FLAG' | transloco | uppercase }}</label>
            <div class="review-metrics">{{patchFlagValue}}</div>
          </div>
          <div class="form-fields">
            <label class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'ADD_VERSION.STATUS' | transloco | uppercase }}</label>
            <div class="review-metrics">{{createVersionForm.getRawValue().status}}</div>
          </div>
          <div class="form-fields">
            <label class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'ADD_VERSION.DESCRIPTION' | transloco | uppercase }}</label>
            <div class="review-metrics">{{createVersionForm.getRawValue().description}}</div>
          </div>
          <div class="form-fields">
            <label class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'ADD_VERSION.RELEASE_NOTES' | transloco | uppercase }}</label>
            <div class="review-metrics">{{createVersionForm.getRawValue().releaseNotes}}</div>
          </div>
          <div class="form-fields">
            <label class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'ADD_VERSION.PRODUCT_VERSION_MAP' | transloco | uppercase }}</label>
            <div class="review-metrics">{{createVersionForm.getRawValue().productVersionMap}}</div>
          </div>
          <div class="form-fields">
            <label class="mat-subtitle-2 mb-0 fs-14 fw-700">{{'ADD_VERSION.SPEC_VERSION' | transloco | uppercase }}</label>
            <div class="review-metrics">{{createVersionForm.getRawValue().specVersion}}</div>
          </div>
          <div class="form-fields mb-16">
            <div class="mat-subtitle-2 mb-0 fs-14 fw-700 pt-4 pl-4 sub-field">{{'ADD_VERSION.CBASE' | transloco | uppercase }}</div>
            <div class="flex flex-col">
              <div class="sub-field pl-6">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.NAME' | transloco | uppercase }}</label>
                <div class="review-metrics">{{createVersionForm.getRawValue().cbaseName}}</div>
              </div>
              <div class="sub-field pl-6">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.VERSION' | transloco | uppercase }}</label>
                <div class="review-metrics">{{createVersionForm.getRawValue().cbaseVersion}}</div>
              </div>
              <div class="sub-field pl-6">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.DISABLED' | transloco | uppercase }}</label>
                <div class="review-metrics">{{createVersionForm.getRawValue().cbaseDisabled}}</div>
              </div>
            </div>
          </div>
          <div class="form-fields mb-16">
            <div class="mat-subtitle-2 mb-0 fs-14 fw-700 pt-4 pl-4 sub-field">{{'ADD_VERSION.ATF' | transloco | uppercase }}</div>
            <div class="flex flex-col">
              <div class="sub-field pl-6">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.NAME' | transloco | uppercase }}</label>
                <div class="review-metrics">{{createVersionForm.getRawValue().atfName}}</div>
              </div>
              <div class="sub-field pl-6">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.VERSION' | transloco | uppercase }}</label>
                <div class="review-metrics">{{createVersionForm.getRawValue().atfVersion}}</div>
              </div>
            </div>
          </div>
        </div>
       
          
     
      
        <mat-divider class="w-100-percent divider mb-16 mt-16"></mat-divider>

        <div class="flex flex-row justify-between items-center mat-subtitle-2 mb-0 fs-20 fw-700 pb-8" *ngIf="capabilityCount.included > 0">
          <div class="pb-4">{{'ADD_VERSION.INCLUDED_CAPABILITIES' | transloco }}</div>
          <div class="flex flex-row cursor-pointer" (click)="selectedIndex = 1">
            <mat-icon svgIcon="edit" class="cursor-pointer icon-md mr-8"></mat-icon>
            <span>{{'ADD_VERSION.EDIT' | transloco }}</span>
          </div>
        </div>
        <div class="flex flex-row flex-wrap gap-x-4" *ngIf="capabilityCount.included > 0">
          <ng-container *ngFor="let capability of dataSource">
            <div *ngIf="capability.type === 'mandatory'" class="form-fields">
              <span>{{capability.capability}}</span><span class="pl-4">({{capability.version}})</span>
            </div>
          </ng-container>
        </div>
        <mat-divider class="w-100-percent divider mb-16 mt-16" *ngIf="capabilityCount.included > 0"></mat-divider>

        <div class="flex flex-row justify-between items-center mat-subtitle-2 mb-0 fs-20 fw-700 pb-8" *ngIf="capabilityCount.optional > 0">
          <div class="pb-4">{{'ADD_VERSION.OPTIONAL_CAPABILITIES' | transloco }}</div>
          <div class="flex flex-row cursor-pointer" (click)="selectedIndex = 1">
            <mat-icon svgIcon="edit" class="cursor-pointer icon-md mr-8"></mat-icon>
            <span>{{'ADD_VERSION.EDIT' | transloco }}</span>
          </div>
        </div>
        <div class="flex flex-row flex-wrap gap-x-4" *ngIf="capabilityCount.optional > 0">
          <ng-container *ngFor="let capability of dataSource">
            <div *ngIf="capability.type === 'optional'" class="form-fields">
              <span>{{capability.capability}}</span><span class="pl-4">({{capability.version}})</span>
            </div>
          </ng-container>
        </div>
        <mat-divider class="w-100-percent divider mb-16 mt-16" *ngIf="capabilityCount.optional > 0"></mat-divider>

        <div class="flex flex-row justify-between items-center mat-subtitle-2 mb-0 fs-20 fw-700 pb-12">
          {{'ADD_VERSION.INSTALLATION_SPECIFICATION' | transloco }}
        </div>
        <div class="pb-16">
          {{ createSpecForm.getRawValue().installationSpecification }}
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  
  <div class="footer pt-16" >
    <div class="flex flex-row justify-end gap-x-6">
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button *ngIf="selectedIndex !== 3" class="accent" type="button" (click)="nextTab()">{{ 'ADD_VERSION.NEXT' | transloco}}</button>
      <button *ngIf="selectedIndex === 3" class="accent" type="button" (click)="submitBuildVersion()">{{ 'ADD_VERSION.SUBMIT' | transloco}}</button>
    </div>
  </div>
</div>